var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindowsImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-47f19f5f": "",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39 39",
    "aria-hidden": "true",
    role: "img",
    className: "icon icon-windows sm pwa-icon pwa-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 5.496l15.816-2.154.007 15.256-15.809.09L0 5.496zm15.808 14.86l.013 15.269L.012 33.45V20.253l15.796.103zM17.726 3.06L38.696 0v18.404l-20.97.166V3.06zM38.7 20.499l-.005 18.322-20.97-2.96-.03-15.396 21.005.034z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsImg);
export default __webpack_public_path__ + "static/media/windows-img.601d6e11605950a09e36807d2f6876a7.svg";
export { ForwardRef as ReactComponent };